import { Badge, Breadcrumb, Col, Dropdown, Layout, Menu, Row, Space } from "antd";
import dayjs from "dayjs";
import _, { cloneDeep, trim } from "lodash";
import { FC, ReactNode, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { StoreExample } from "../../../commons/constants";
import { menusMerchantMember } from "../../../commons/constants/menus";
import { routerNavigation, routers } from "../../../commons/constants/routers";
import { Notification, TrifoodLogo } from "../../../commons/resources";
import { AppContext } from "../../../contexts/AppContext";
import { AppTencentContext } from "../../../contexts/ChatContext";
import AccountDropdown from "./AccountDropdown";
import "./custom-layout.module.scss";
import styles from "./custom-layout.module.scss";
import "./index.scss";
import { STORE_TYPE } from "../../../commons/constants/store";

const LayoutMerchantMember: FC<{ children: ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const { notifications, handleReadNotification, unreadNotifications } = useContext(AppTencentContext);
  const { currentStore, isMobile } = useContext(AppContext);
  const [collapsed, setCollapsed] = useState(isMobile);
  const { pathname } = useLocation();
  const sideMenuRef = useRef<any>(null);

  const surplusTypeStore = currentStore && currentStore?.type === STORE_TYPE.SURPLUS;
  const foodDeliveryTypeStore = currentStore && currentStore?.type === STORE_TYPE.FOOD_DELIVERY;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (sideMenuRef.current && !sideMenuRef.current.contains(event.target)) {
        turnOffCollapse();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const turnOffCollapse = () => {
    if (!isMobile) return;
    setCollapsed(true);
  };

  const isDetailChecking = pathname.split("/").length === 5 && pathname.includes("order-tracking");

  const handleViewAll = () => {
    navigate(routers.NOTIFICATION);
  };

  const handleTitle = (item: any) => {
    const { content } = item;
    const { message } = content;
    let messageCLone = cloneDeep(message);
    const listKey = _.keys(content).filter(item => item !== "message");
    let res;
    if (listKey.length > 0) {
      res = listKey.reduce((message: string, value: string) => {
        return (message as string)?.replace(
          `:${value}`,
          `<span style="color:#fff ; font-weight: 600">${content[value]}</span>`
        );
      }, messageCLone);
    } else {
      res = message;
    }

    return {
      __html: `<div style="font-size: 14px; color: #ABABB1; font-weight: 400; cursor: pointer">${res}</div>`,
    };
  };

  function getActivePathName(pathname: string) {
    const orderTrackingPath = routerNavigation.STORES.ORDER_TRACKING(currentStore?.id ? currentStore?.id : "");
    if (pathname.startsWith(orderTrackingPath)) {
      return orderTrackingPath;
    }

    const refundManagement = routerNavigation.STORES.REFUND_MANAGEMENT(currentStore?.id ? currentStore?.id : "");
    if (pathname.startsWith(refundManagement)) {
      return refundManagement;
    }

    const rateManagement = routerNavigation.STORES.RATE_MANAGEMENT(currentStore?.id ? currentStore?.id : "");
    if (pathname.startsWith(rateManagement)) {
      return rateManagement;
    }

    const recon = routers.RECONCILIATION;
    if (pathname.startsWith(recon)) {
      return recon;
    }

    const campaign = routers.LP_MEMBER_SHIP.CAMPAIGN_LIST;
    if (pathname.startsWith("/lp-membership/campaign")) {
      return campaign;
    }

    return pathname;
  }

  const subTitle = useMemo(() => {
    if (
      pathname.includes(routers.STORES.PRODUCT_MANAGEMENT.replace(":storeId", currentStore?.id as any)) ||
      pathname.includes(routers.STORES.CREATE_PRODUCT.replace(":storeId", currentStore?.id as any))
    ) {
      return "Product management";
      // } else if (pathname.includes(routers.STORES.BADGE_MANAGEMENT.replace(":storeId", currentStore?.id as any))) {
      //   return "Badge Management";
      // } else if (pathname.includes(routers.STORES.CREATE_BADGE.replace(":storeId", currentStore?.id as any))) {
      //   return "Create new Badge";
    } else if (
      pathname.includes(routers.STORES.SURPLUS_MANAGEMENT.replace(":storeId", currentStore?.id as any)) ||
      pathname.includes(routers.STORES.CREATE_SURPLUS.replace(":storeId", currentStore?.id as any))
    ) {
      return "Surplus management";
    } else if (pathname.includes(routers.STORES.ORDER_TRACKING.replace(":storeId", currentStore?.id as any))) {
      return "Order Tracking";
    } else if (pathname.includes(routers.STORES.ORDER_TRACKING_DETAIL.replace(":storeId", currentStore?.id as any))) {
      return "Order Detail";
    } else if (pathname.includes(routers.STORES.RATE_MANAGEMENT.replace(":storeId", currentStore?.id as any))) {
      return "Rate Management";
      // } else if (pathname.includes(routers.STORES.CHAT_INBOX.replace(":storeId", currentStore?.id as any))) {
      //   return "Chat Inbox";
    } else if (pathname.includes(routers.STORES.REPORT.replace(":storeId", currentStore?.id as any))) {
      return "Report";
    } else if (pathname.includes(`/voucher/`) || pathname.includes("/edit-voucher/")) {
      return "Voucher detail";
    } else if (pathname.includes(routers.STORES.CREATE_VOUCHER.replace(":storeId", currentStore?.id as any))) {
      return "Voucher management";
    } else if (
      pathname.includes(routers.LP_MEMBER_SHIP.CAMPAIGN_LIST) ||
      pathname.includes(routers.LP_MEMBER_SHIP.CAMPAIGN_DETAIL)
    ) {
      return "Marketing Campaign";
    } else {
      return "Store List";
    }
  }, [pathname, currentStore?.id]);

  const subTitle2 = useMemo(() => {
    if (pathname.includes(routers.STORES.CREATE_PRODUCT.replace(":storeId", currentStore?.id as any))) {
      return "Add new product";
    } else {
      return "";
    }
  }, [pathname, currentStore?.id]);

  let activePathName = getActivePathName(pathname);

  const countNotificationPlus = useMemo(() => {
    if (!unreadNotifications) return null;
    if (unreadNotifications > 99) {
      return "99+";
    } else {
      return unreadNotifications;
    }
  }, [unreadNotifications]);

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <Layout.Sider
        ref={sideMenuRef}
        onCollapse={() => {
          if (!isMobile) return;
          setCollapsed(cl => !cl);
        }}
        collapsed={collapsed}
        collapsedWidth={0}
        collapsible={isMobile}
        width={280}
        className={`${styles.slider_menu} ${isMobile && "is-mobile"}`}
        breakpoint="md"
      >
        <Link to={routers.DASHBOARD} className={styles.logoLink} onClick={turnOffCollapse}>
          <TrifoodLogo width="auto" height={40} />
        </Link>
        <Menu
          className={styles.menu}
          theme="dark"
          mode="inline"
          selectedKeys={[activePathName]}
          defaultOpenKeys={[routers.STORES.LIST]}
          style={{ height: "calc(100% - 80px)", overflow: "auto" }}
          items={menusMerchantMember(currentStore?.id)
            .filter(value => {
              if (currentStore.name === StoreExample.name && value.isStore) {
                return false;
              }
              return true;
            })
            .map(({ isStore, path, icon: Icon, label, hasNotify, children, count, renderPath }) => {
              if (!isStore || !children) {
                return {
                  key: (currentStore && renderPath?.(currentStore?.id)) || path,
                  path: (currentStore && renderPath?.(currentStore?.id)) || path,
                  label: (
                    <Link to={(currentStore && renderPath?.(currentStore?.id)) || path} onClick={turnOffCollapse}>
                      <span>{label}</span>
                      {path === routers.NOTIFICATION && hasNotify && countNotificationPlus && (
                        <span className={styles.menuItemCount}>{countNotificationPlus}</span>
                      )}
                    </Link>
                  ),
                  icon: <Icon />,
                };
              }

              return {
                key: (currentStore && renderPath?.(currentStore?.id)) || path,
                path: (currentStore && renderPath?.(currentStore?.id)) || path,
                label: (
                  <Link to={(currentStore && renderPath?.(currentStore?.id)) || path}>
                    <span>{isStore ? `${trim(currentStore.name)}` : label}</span>
                  </Link>
                ),
                icon: <Icon />,
                children: children.map(item => {
                  if (item.path === routers.STORES.PRODUCT_MANAGEMENT && !foodDeliveryTypeStore) {
                    return undefined;
                  }
                  if (item.path === routers.STORES.SURPLUS_MANAGEMENT && !surplusTypeStore) {
                    return undefined;
                  }

                  return {
                    key: (currentStore && item.renderPath?.(currentStore?.id)) || item.path,
                    path: (currentStore && item.renderPath?.(currentStore?.id)) || item.path,
                    label: (
                      <Menu.Item onClick={turnOffCollapse}>
                        <Link to={(currentStore && item.renderPath?.(currentStore?.id)) || item.path}>
                          {item.label}
                        </Link>
                      </Menu.Item>
                    ),
                  };
                }),
              };
            })}
        />
      </Layout.Sider>
      <Layout>
        {!collapsed && isMobile && <div className="sidemenu__masker"></div>}
        <Layout.Header className={styles.header}>
          <Breadcrumb separator="" className={styles.breadcrumb_cover}></Breadcrumb>

          <Space size={30} className={`header_right ${isMobile && "is-mobile"}`}>
            <Dropdown
              trigger={["hover"]}
              overlay={
                <div className={"dropdownNoti"}>
                  {notifications.map(item => {
                    return (
                      <Row
                        key={item.read_at}
                        className="item"
                        onClick={() => handleReadNotification(item)}
                        style={!dayjs(item.read_at).isValid() ? {} : { opacity: 0.6 }}
                      >
                        <Col span={23} className={"record"}>
                          <div dangerouslySetInnerHTML={handleTitle(item)} />
                          <div className="date">{dayjs(item?.notify_at).format("DD/MM/YYYY HH:mm")}</div>
                        </Col>
                        <Col span={1} className="badge">
                          <div>{!dayjs(item.read_at).isValid() && <Badge key={"blue"} color={"#F4E85B"} />}</div>
                        </Col>
                      </Row>
                    );
                  })}
                  <div className="viewAll" onClick={handleViewAll}>
                    View all notifications
                  </div>
                </div>
              }
              placement="bottomRight"
              overlayClassName="dropdown-wrapper"
            >
              <Badge count={unreadNotifications} className="header_noti">
                <Notification />
              </Badge>
            </Dropdown>
            {isMobile && (
              <Link to={routers.DASHBOARD} className={styles.logoLink}>
                <TrifoodLogo width="auto" height={40} />
              </Link>
            )}
            <AccountDropdown />
          </Space>
        </Layout.Header>
        <Layout.Content className={styles.main}>{children}</Layout.Content>
      </Layout>
    </Layout>
  );
};

export default LayoutMerchantMember;
